import { Controller } from '@hotwired/stimulus';
import Redactor from '../../../vendor/javascript/redactor.min';
import '../../../vendor/javascript/redactor/plugins';

export default class extends Controller {
  connect () {
    const csrfToken = document.querySelector('meta[name=csrf-token]').content;
    const csrfParam = document.querySelector('meta[name=csrf-param]').content;

    let params;
    if (csrfParam !== undefined && csrfToken !== undefined) {
      params = csrfParam + '=' + encodeURIComponent(csrfToken);
    }

    this.redactorInstance = Redactor(this.element, {
      subscribe: { 'editor.change': (event) => { this._checkValidity(event) } },
      image: { upload: '/redactor/image_upload?' + params },
      plugins: ['alignment', 'fontColor', 'imageresize']
    });

    this.container = this.element.nextElementSibling;

    if (this.element.classList.contains('is-invalid')) {
      this._addError();
    }

    this.observer = new MutationObserver((mutationList, _) => this._onMutation(mutationList));
    this.observer.observe(this.element, { attributeFilter: ['disabled'] });
    this.element.addEventListener('clear', (event) => { this._onClear(event); });
    this.element.addEventListener('invalid', (_) => { this._addError(); });
  }

  disconnect () {
    this.observer.disconnect();
  }

  _onMutation (mutationList) {
    for (const mutation of mutationList) {
      if (this.element.disabled && !this.redactorInstance.disableMode) {
        this.redactorInstance.disable();
      } else if (!this.element.disabled && this.redactorInstance.disableMode) {
        this.redactorInstance.enable();
      }
    }
  }

  _onClear (_) {
    this.redactorInstance.editor.setContent({ html: '' });
  }

  _checkValidity (event) {
    const content = this.redactorInstance.editor.getContent();

    if (this.element.required && content.trim() == '') {
      this._addError();
    } else {
      this._clearError();
    }
  }

  _addError () {
    this.container.classList.add('rx-invalid');
  }

  _clearError () {
    this.container.classList.remove('rx-invalid');
  }
}
